import React, {useEffect, useRef, useState} from "react"
import Image from "next/image";
import Box from '@mui/material/Box';
import {SxProps, Theme} from '@mui/material/styles';
import {getAltText} from "./CCOPicture";

interface Props {
    children?: JSX.Element | JSX.Element[],
    image: {
        src: string,
        alt: string,
        isColor: boolean,
        width: number,
        isObjectFit?: boolean,
        title?: string,
    } | null,
    imageOverlay?: React.ReactNode
    hero?: boolean
    color?: string
}

const backgroundImageStyle = (hero?: boolean, isColor?: boolean,
                              color?: string): SxProps<Theme> => ({
    position: "relative",
    height: 'auto',
    display: "flex",
    alignItems: hero ? "center" : "end",
    justifyContent: "center",
    overflow: "hidden",
    textAlign: "left",
    backgroundColor: isColor ? color : "transparent",
    "& img": {
        position: 'relative !important'
    }
});

const textContentStyle = (hero?: boolean): SxProps<Theme> => (theme) => ({
    position: "absolute",
    color: theme.palette.text.primary,
    display: "flex",
    alignItems: "start",
    justifyContent: "start",
    flexDirection: "column",
    width: "100%",
    zIndex: 0, // Added a z-index so that this div stays above the Image component
    marginBottom: hero ? 0 : theme.spacing(10)
});

function CCOTextOverlay(props: Props) {
    const [isVisible, setIsVisible] = useState(false);
    const targetRef = useRef(null);

    useEffect(() => {
        if (targetRef.current) {
            // without this, react gives a warning during the build
            // must be silly react-voodoo, but works now without that warning
            let observerRefValue = null as any;
            const intersectionObserver = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    setIsVisible(true);
                }
            });

            if (targetRef.current) {
                intersectionObserver.observe(targetRef.current);
                observerRefValue = targetRef.current;
            }
            return () => {
                if (observerRefValue) {
                    intersectionObserver.unobserve(observerRefValue);
                }
            }
        }
    }, [isVisible]);
    const loadedStyle = {
        width: "100%",
        height: "auto"
    }
    const objectFit = {
        objectFit: "cover",
        width: "100%",
        height: "auto"
    }

    return <div ref={targetRef}>
        <Box sx={backgroundImageStyle(props.hero, props.image?.isColor, props.color)}>
            {isVisible ?
                <>
                    {
                        props.image ? <Image src={props?.image.src}
                                             alt={getAltText(props?.image.alt, props?.image.title)}
                                             width={+props?.image.width}
                                             height={+props?.image.width}
                                             style={props.image.isObjectFit ? objectFit :
                                                 loadedStyle}
                        /> : null
                    }
                    {props.imageOverlay}
                    <Box sx={textContentStyle(props.hero)}>
                        {props.children}
                    </Box>
                </> : null
            }
        </Box>
    </div>

}


export default CCOTextOverlay